var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.194656372070312, 8.149694442749023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.57 2.04 C 9.57 1.22 9.50 0.62 9.36 0.00 L 0.00 0.00 L 0.00 3.70 L 5.49 3.70 C 5.38 4.62 4.78 6.00 3.45 6.93 L 3.44 7.06 L 6.39 9.35 L 6.60 9.37 C 8.48 7.63 9.57 5.07 9.57 2.04",
    fill: "#4285f4",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.2919847965240479, 11.936640739440918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.90 7.99 C 11.59 7.99 13.85 7.11 15.50 5.58 L 12.36 3.14 C 11.52 3.73 10.39 4.14 8.90 4.14 C 6.27 4.14 4.03 2.40 3.23 0.00 L 3.12 0.01 L 0.04 2.39 L 0.00 2.50 C 1.64 5.76 5.00 7.99 8.90 7.99",
    fill: "#34a853",
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.22900772094726562, 5.443663597106934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.30 6.49 C 4.09 5.87 3.96 5.21 3.96 4.52 C 3.96 3.84 4.09 3.17 4.29 2.55 L 4.28 2.42 L 1.16 0.00 L 1.06 0.05 C 0.39 1.40 0.00 2.92 0.00 4.52 C 0.00 6.13 0.39 7.64 1.06 9.00 L 4.30 6.49",
    fill: "#fbbc05",
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.2919847965240479, 8.940696716308594e-8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.90 3.85 C 10.77 3.85 12.04 4.66 12.76 5.34 L 15.57 2.59 C 13.84 0.99 11.59 0.00 8.90 0.00 C 5.00 0.00 1.64 2.24 0.00 5.49 L 3.22 7.99 C 4.03 5.59 6.27 3.85 8.90 3.85",
    fill: "#eb4335",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b58821caf931b0932edc0d257265c778.svg";
export { ForwardRef as ReactComponent };